import actionCreator from "helpers/actionCreator"
import { createDefaultReducer } from "helpers/reducers"
import { createReducer } from "reduxsauce"
import { createFactorViewPayload } from "modules/factor-trends-risk/helpers/tracking"

export const { Types, Creators } = actionCreator("ompnt/modules/factorTrendsRiskDetails", {
  sort: {
    props: ["order"],
    track: true,
    trackType: "factor-trends-contributors-sorting",
    trackPayload: ({ order }) => createFactorViewPayload({ order }),
  },
})

const DEFAULT_STATE = {}
export default createReducer(DEFAULT_STATE, {})

export const queryStringReducers = {
  [Types.SORT]: createDefaultReducer(),
}
